"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.controls.knowledgePicker.label': 'Seleziona Conoscenza',
    'ai.controls.knowledgePicker.show': 'Usa Base di Conoscenza',
};
